import { render, staticRenderFns } from "./StatsPictures.vue?vue&type=template&id=17b20ae9&scoped=true"
import script from "./StatsPictures.vue?vue&type=script&lang=js"
export * from "./StatsPictures.vue?vue&type=script&lang=js"
import style0 from "./StatsPictures.vue?vue&type=style&index=0&id=17b20ae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b20ae9",
  null
  
)

export default component.exports